import React, { useEffect, useState, useMemo } from "react";
import { Layout } from "@/components/Layout";
import { ContentCard } from "@/components/ContentCard";
import api from "@/lib/api";

const LANGS = ["All", "Hindi", "Marathi", "Tamil", "Telugu", "English"];

export default function Browse({ mode }) {
  const cfg = {
    movies: { title: "Movies", subtitle: "Blockbusters, indies and KalamPrime Originals.", params: { type: "movie" } },
    series: { title: "Web Series", subtitle: "Binge-worthy stories, only on KalamPrime.", params: { type: "series" } },
    originals: { title: "KalamPrime Originals", subtitle: "Your Story Starts Here.", params: { original: true } },
    kids: { title: "Kids", subtitle: "Safe, colourful and made for little explorers.", params: { type: "kids" } },
  }[mode];

  const [items, setItems] = useState(null);
  const [lang, setLang] = useState("All");

  useEffect(() => {
    setItems(null);
    api.get("/content", { params: cfg.params }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [mode]);

  const filtered = useMemo(() => {
    if (!items) return [];
    return lang === "All" ? items : items.filter((i) => i.languages?.includes(lang));
  }, [items, lang]);

  return (
    <Layout>
      <div className={`pt-28 px-4 md:px-12 ${mode === "kids" ? "bg-gradient-to-b from-[#12204a] to-[#0B0E14]" : ""}`}>
        <div className="fade-up">
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-white">{cfg.title}</h1>
          <p className="text-slate-400 mt-2">{cfg.subtitle}</p>
        </div>

        {mode !== "kids" && (
          <div className="flex gap-2 mt-6 flex-wrap">
            {LANGS.map((l) => (
              <button
                key={l}
                data-testid={`filter-lang-${l.toLowerCase()}`}
                onClick={() => setLang(l)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
                  lang === l ? "bg-[var(--nik-blue)] text-white" : "bg-white/5 text-slate-300 hover:bg-white/10"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
        )}

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 pb-12">
          {items === null
            ? Array.from({ length: 12 }).map((_, i) => <div key={i} className="aspect-[2/3] rounded-lg skeleton" />)
            : filtered.map((item) => (
                <div key={item.id} className="flex justify-center">
                  <ContentCard item={item} />
                </div>
              ))}
        </div>
        {items && filtered.length === 0 && (
          <div className="text-slate-400 py-20 text-center">No titles found for this filter.</div>
        )}
      </div>
    </Layout>
  );
}
